import React from 'react';

import Layout from '../components/layout';
import { renderSearchPage } from '../templates/search';

const Search = () => {
  const seoSlug = 'search';

  return <Layout>{renderSearchPage(null, seoSlug)}</Layout>;
};

export default Search;
